import { Clock } from "lucide-react";
import { useLiveStats } from "@/lib/liveStats";

export default function FastHighlight() {
  const stats = useLiveStats();
  return (
    <section
      data-testid="fast-highlight-section"
      className="py-24 md:py-32 bg-stone-900 text-stone-50 relative grain overflow-hidden"
    >
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 text-center">
        <Clock className="w-6 h-6 mx-auto mb-7 text-[#C7A97B]" strokeWidth={1.2} />
        <p className="overline mb-7 text-stone-400">The 72-hour promise</p>
        <h2 className="font-serif text-[2.6rem] sm:text-[3.4rem] md:text-[4.6rem] leading-[1.04] tracking-tight">
          Your highlight film,
          <br />
          <em className="italic font-normal text-stone-400">within 72 hours.</em>
        </h2>
        <p className="mt-8 font-serif text-stone-300 text-lg md:text-xl leading-relaxed max-w-2xl mx-auto">
          Most videographers make you wait months to see anything. Every Wedding Video
          Essex couple receives a sneak peek film within 72 hours of their wedding —
          and most get theirs in 24 to 48. It is the single most talked-about moment
          in our {stats.total} reviews.
        </p>
        <blockquote
          data-testid="fast-highlight-quote"
          className="mt-12 font-serif italic text-[1.5rem] md:text-[1.9rem] leading-[1.35] text-stone-100 max-w-2xl mx-auto"
        >
          &ldquo;We were very impressed with how quickly they sent over the highlight
          video. It was less than 24 hours after our wedding!&rdquo;
        </blockquote>
        <p className="mt-5 font-serif text-stone-400">
          Emma &amp; Jamie ·{" "}
          <a
            href="https://guidesforbrides.co.uk/wedding-videographers-and-video/essex/wedding-video-essex/165670"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 hover:text-stone-200 transition-colors"
            data-testid="fast-highlight-source-link"
          >
            verified on Guides for Brides
          </a>
        </p>
      </div>
    </section>
  );
}
